module.exports = (__webpack_require__(0))(143);


//////////////////
// WEBPACK FOOTER
// delegated ./clients/web/src/views/App.js from dll-reference girder_lib
// module id = 122
// module chunks = 0